var exports = {
  "k": "x804f0401--f70e83--container",
};

module.exports = exports;
